/**
 * Shared share-link handlers for product and bundle detail pages.
 * Encapsulates Facebook popup, WhatsApp, Pinterest, and icon filter logic
 * so that both ProductShareLinks (PDP) and BundleShareButton (BDP) stay DRY.
 *
 * @param partNumber - product/bundle partNumber used to build the Pinterest media URL
 * @param onClose    - optional callback invoked after each share action (e.g. close a menu)
 */

import {
	CDN_BASE_URL,
	HD_BASE_URL,
	MATERIAL_SYMBOL_ICONS,
} from 'shared/custom/constants/commonConstants';

export const SHARE_ICON_FILTER =
	'invert(32%) sepia(17%) saturate(1162%) hue-rotate(165deg) brightness(91%) contrast(85%)';

export const useShareLinks = (partNumber?: string, onClose?: () => void) => {
	const handleFacebook = () => {
		const w = 450;
		const h = 600;
		const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
		const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;
		const width = window.innerWidth || document.documentElement.clientWidth || window.screen.width;
		const height =
			window.innerHeight || document.documentElement.clientHeight || window.screen.height;
		const systemZoom = width / window.screen.availWidth;
		const left = (width - w) / 2 / systemZoom + dualScreenLeft;
		const top = (height - h) / 2 / systemZoom + dualScreenTop;
		const params = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,width=${w},height=${h},left=${left},top=${top}`;
		window.open(
			encodeURI(`https://www.facebook.com/sharer/sharer.php?u=${document.URL}`),
			'Facebook share',
			params
		);
		onClose?.();
	};

	const handleWhatsApp = () => {
		const url = encodeURIComponent(window.location.href);
		window.open(`https://wa.me/?text=${url}`, '_blank');
		onClose?.();
	};

	const handlePinterest = () => {
		let url = HD_BASE_URL;
		if (window.location.hostname !== 'localhost') {
			url = window.location.href;
		}
		const pinterestURL = encodeURI(url);
		const description = encodeURI(document.title);
		const media = `${CDN_BASE_URL}/productos/${partNumber}/${partNumber}.jpg`;
		window.open(
			`https://www.pinterest.com/pin/create/button/?url=${pinterestURL}&media=${media}&description=${description}`,
			'_blank'
		);
		onClose?.();
	};

	const shareOptions = [
		{
			icon: `${CDN_BASE_URL}/assets/icons/facebook.svg`,
			name: 'Facebook',
			onClick: handleFacebook,
			materialIcon: MATERIAL_SYMBOL_ICONS.facebook,
		},
		{
			icon: `${CDN_BASE_URL}/assets/icons/whatsapp-new.svg`,
			name: 'WhatsApp',
			onClick: handleWhatsApp,
			materialIcon: MATERIAL_SYMBOL_ICONS.whatsapp,
		},
		{
			icon: `${CDN_BASE_URL}/assets/icons/pinterest.svg`,
			name: 'Pinterest',
			onClick: handlePinterest,
			materialIcon: MATERIAL_SYMBOL_ICONS.pinterest,
		},
	];

	return { handleFacebook, handleWhatsApp, handlePinterest, shareOptions };
};
